  export const getDateTimeString = () => {
    const now = new Date();

    const date = now.toISOString().slice(0, 10);

    const time = now.toTimeString().split(" ")[0];

    const millis = now.getMilliseconds().toString().padStart(3, "0");

    const micro = millis + "00";

    return `${date} ${time}.${micro}`;
  };